import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { STOCK_TABS } from "../stock.constants";

interface StockTabsToolbarProps {
  includeInactive: boolean;
  onIncludeInactiveChange: (value: boolean) => void;
}

export function StockTabsToolbar({
  includeInactive,
  onIncludeInactiveChange,
}: StockTabsToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 border-y border-border py-3 lg:flex-row lg:items-center lg:justify-between">
      <TabsList className="w-fit border-b-0">
        <TabsTrigger value={STOCK_TABS.articles}>Articles</TabsTrigger>
        <TabsTrigger value={STOCK_TABS.movements}>Mouvements</TabsTrigger>
      </TabsList>

      <label className="flex h-10 w-fit items-center gap-2 rounded-lg border border-border bg-card px-3 text-[12px] text-body">
        <input
          type="checkbox"
          checked={includeInactive}
          onChange={(event) => onIncludeInactiveChange(event.target.checked)}
          className="accent-brand-gold-dark"
        />
        Inclure les articles désactivés
      </label>
    </div>
  );
}
